/* ------------------------------------------------------------------
   Orléa — LES PILLS SUR UNE RANGÉE QUI DÉFILE (flèches)
   ------------------------------------------------------------------
   Demande Simon (2026-07-29) : « une rangée seulement, avec une flèche
   qui peut faire tasser de droite à gauche. »

   Ce script pose deux flèches autour de `.ocol-pills-rail` et pilote le
   défilement. Le style vit dans assets/orlea-pills-rail.css.

   ⚠ LES FLÈCHES N'APPARAISSENT QUE SI ÇA DÉBORDE. Sur un grand écran
   avec peu de familles, elles n'ont pas lieu d'être — on ne les affiche
   pas plutôt que de les griser en permanence.
   (Mesuré : invisibles à 1512px, visibles à 1000px avec 7 pills.)

   ⚠ RECALCUL AU REDIMENSIONNEMENT : le débordement dépend de la largeur.

   ⚠ La page collection RE-REND sa grille au filtrage (contrat Flaunt),
   mais la barre de pills vit HORS de la zone re-rendue. Un garde-fou
   `_orail` évite malgré tout un double câblage.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var PAS_RATIO = 0.72;  // un clic déplace ~3/4 de la largeur visible
  var MARGE = 2;         // largeurs fractionnaires : éviter les faux positifs

  function fleche(sens, libelle) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ocol-prail-btn ocol-prail-btn--' + sens;
    b.setAttribute('aria-label', libelle);
    // textContent, pas innerHTML : le chevron est un simple caractère.
    b.textContent = sens === 'prev' ? '‹' : '›';
    return b;
  }

  function cabler(zone) {
    if (zone._orail) return;
    var rail = zone.querySelector('.ocol-pills-rail');
    if (!rail) return;
    zone._orail = true;

    var prev = fleche('prev', 'Voir les catégories précédentes');
    var next = fleche('next', 'Voir les catégories suivantes');
    zone.appendChild(prev);
    zone.appendChild(next);

    function etat() {
      var deborde = rail.scrollWidth > rail.clientWidth + MARGE;
      zone.dataset.orail = deborde ? 'oui' : 'non';

      if (!deborde) {
        zone.dataset.oprev = 'non';
        zone.dataset.onext = 'non';
        return;
      }
      var max = rail.scrollWidth - rail.clientWidth;
      var aGauche = rail.scrollLeft > MARGE;
      var aDroite = rail.scrollLeft < max - MARGE;

      zone.dataset.oprev = aGauche ? 'oui' : 'non';
      zone.dataset.onext = aDroite ? 'oui' : 'non';
      prev.disabled = !aGauche;
      next.disabled = !aDroite;
    }

    function pousser(signe) {
      rail.scrollBy({ left: signe * rail.clientWidth * PAS_RATIO, behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { pousser(-1); });
    next.addEventListener('click', function () { pousser(1); });

    var raf = null;
    rail.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; etat(); });
    }, { passive: true });

    if (window.ResizeObserver) {
      new ResizeObserver(etat).observe(rail);
    } else {
      window.addEventListener('resize', etat);
    }

    /* ── La pill active doit être visible à l'arrivée ──
       🔴 PIÈGE CORRIGÉ : un `scrollIntoView` centré systématique coupait la
       PREMIÈRE pill en deux et la cachait sous la flèche gauche (constaté en
       capture sur « Lip Oil & Lipstick », la pill active la plus courante).

       Règle : on ne déplace le rail QUE si la pill active déborde vraiment
       du cadre. Une pill déjà visible — en particulier la première — ne
       bouge pas. */
    var pills = rail.querySelectorAll('.ocol-pill');
    var active = rail.querySelector('.ocol-pill.is-on, .ocol-pill[aria-current="page"]');
    if (active && pills.length) {
      var premiere = active === pills[0];
      var derniere = active === pills[pills.length - 1];
      var a = active.getBoundingClientRect();
      var c = rail.getBoundingClientRect();
      // Le padding du rail réserve la place des flèches : une pill « sous »
      // une flèche est considérée hors cadre.
      var pad = parseFloat(getComputedStyle(rail).paddingLeft) || 0;
      var horsGauche = a.left < c.left + pad - MARGE;
      var horsDroite = a.right > c.right - pad + MARGE;

      if (premiere) {
        rail.scrollLeft = 0;                       // toujours collée au début
      } else if (derniere) {
        rail.scrollLeft = rail.scrollWidth;        // borné par le navigateur
      } else if (horsGauche || horsDroite) {
        rail.scrollLeft = active.offsetLeft - rail.clientWidth / 2 + active.offsetWidth / 2;
      }
    }

    etat();
  }

  function init() {
    document.querySelectorAll('.ocol-pills').forEach(cabler);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
